import { PermissionsProps, usePermissions } from 'hooks/usePermissions';
import { Navigate, Outlet } from 'react-router-dom';

export const PermissionProtectedRoute = (props: PermissionsProps) => {
  const { hasPermission } = usePermissions(props);

  if (!hasPermission) return <Navigate to="/" />;
  return <Outlet />;
};
